import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';

function Start({ action, variables, setOpenVariable, showAlert }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.AUTOMS.START.';
    return (
        <div>
            <div className="form-element">
                {t(label + 'PROCESS-NAME')}
                <TextInput action={action} inputName="name" variables={variables} setOpenVariable={setOpenVariable}/>
            </div>
            <div className="form-element">
                {t(label + 'REQUEST-TITLE')}
                <TextInput action={action} inputName="requestTitle" variables={variables} setOpenVariable={setOpenVariable}/>
            </div>
        </div>
    )
}

export default Start;
